function Aa(text) {
  if (text == null || typeof text !== "string") return "";
  return text.slice(0, 1).toUpperCase() + text.slice(1);
}

export { Aa };
